// extracted by mini-css-extract-plugin
export default {"layout":"HomePage_layout__ryoiX","leftTab":"HomePage_leftTab__asqL+"};